module.exports = __webpack_public_path__ + "img/sld_LT_2.250da454.svg";